import { render, staticRenderFns } from "./subject_literature.vue?vue&type=template&id=032f0d93&scoped=true"
import script from "./subject_literature.vue?vue&type=script&lang=js"
export * from "./subject_literature.vue?vue&type=script&lang=js"
import style0 from "./subject_literature.vue?vue&type=style&index=0&id=032f0d93&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032f0d93",
  null
  
)

export default component.exports